var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bg-white z-index-1 left-0 bottom-0 right-0" },
    [
      _vm.navSelctType == 0
        ? _c("div", { staticStyle: { background: "#F5F5F5" } })
        : _vm._e(),
      _vm.navSelctType == 0
        ? _c(
            "div",
            {
              staticClass: "h-38 l-h-38 p-l-16 f-s-12",
              staticStyle: {
                color: "#999999",
                "border-bottom": "1px solid #f2f2f2",
              },
            },
            [
              _vm._v(
                _vm._s(
                  _vm.currentnavSelctType == "1"
                    ? "网点"
                    : _vm.currentnavSelctType == "2"
                    ? "我的组织"
                    : "群聊"
                )
              ),
            ]
          )
        : _vm._e(),
      _vm.noData && _vm.keyWord
        ? _c("div", { staticClass: "t-a-center p-x-20 l-h-24 p-y-10" }, [
            _vm._v("未搜索到 “" + _vm._s(_vm.keyWord) + "” 的相关内容"),
          ])
        : !_vm.keyWord
        ? [
            _vm._m(0),
            _c(
              "div",
              {
                staticClass: "f-s-12 t-a-center",
                staticStyle: { color: "#999999" },
              },
              [_vm._v("输入关键字开始搜索")]
            ),
          ]
        : _vm._e(),
      _c(
        "ul",
        _vm._l(_vm.searchedData, function (item, index) {
          return (_vm.navSelctType == 0 &&
            3 > index &&
            _vm.currentnavSelctType == 2) ||
            (_vm.navSelctType == 2 && _vm.currentnavSelctType == 2)
            ? _c(
                "li",
                {
                  key: index,
                  staticClass:
                    "d-table w-100-p h-67 b-b b-c-g-100 cursor-default bg-g-50-hover",
                  on: {
                    click: function ($event) {
                      return _vm.itemClickEvent(item)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "d-table-cell v-a-middle h-100-p w-64",
                      staticStyle: { "text-align": "center" },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "d-block m-auto w-40 h-40 l-h-40 t-a-center c-white rounded user-select-none",
                          staticStyle: { "background-color": "#653EB3" },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.getShortNickname(item.nickName || item.mobile)
                            )
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "p-relative d-table-cell v-a-middle h-100-p",
                    },
                    [
                      _c("div", { style: { width: _vm.listWidth + "px" } }, [
                        _c("div", [
                          item.isChinese
                            ? _c("p", {
                                staticClass: "t-ellipsis l-h-1-6-em m-r-10",
                                domProps: {
                                  innerHTML: _vm._s(item.nickNameHtml),
                                },
                              })
                            : _c(
                                "p",
                                { staticClass: "t-ellipsis l-h-1-6-em m-r-10" },
                                [_vm._v(_vm._s(item.nickName))]
                              ),
                          item.isNumber
                            ? _c("p", {
                                staticClass: "t-ellipsis l-h-1-6-em m-r-10",
                                domProps: {
                                  innerHTML: _vm._s(item.mobileHtml),
                                },
                              })
                            : _c(
                                "p",
                                { staticClass: "t-ellipsis l-h-1-6-em m-r-10" },
                                [_vm._v(_vm._s(item.mobile))]
                              ),
                        ]),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e()
        }),
        0
      ),
      _vm.navSelctType == 0 && !_vm.noData && _vm.searchedData.length > 3
        ? _c(
            "div",
            {
              staticClass:
                "h-36 l-h-36 p-l-16 p-r-12 flex justify-content-between align-items-center cursor-pointer",
              staticStyle: {
                color: "#653EB3",
                "border-bottom": "1px solid #f2f2f2",
              },
              on: { click: _vm.selectedContacts },
            },
            [
              _c("span", { staticClass: "d-block" }, [
                _vm._v("查看更多相关我的组织成员"),
              ]),
              _c("img", {
                staticClass: "d-block",
                staticStyle: { width: "8px", height: "14px" },
                attrs: {
                  src: require("@/assets/images/im/arrow-right@2x.png"),
                },
              }),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "t-a-center", staticStyle: { margin: "68px auto auto" } },
      [
        _c("img", {
          attrs: {
            src: require("@/assets/images/im/kong-order@2x.png"),
            width: "155px",
            height: "104px",
          },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }